import { IController } from 'angular';

export class InstructionsStepCtrl implements IController {
  public selectedGradDate: string | null;
}
